import { useState } from 'react'
import { connect } from 'react-redux'
import { toastr } from 'react-redux-toastr'
import reduxFormTouchOnsubmit from 'hocs/reduxFormTouchOnsubmit'
import { ButtonStack, Grid } from 'maple-storybook'
import { getFormValues, reduxForm } from 'redux-form'

import { Button, ItemGrid } from 'components'

import NestedDropdowns from './NestedDropdowns'

let InsertVariableForm = ({ handleInsertVariable, emailTemplatesVariables, isOnboarding }) => {
  const [selectedValue, setSelectedValue] = useState(null)
  let values = isOnboarding ? emailTemplatesVariables : emailTemplatesVariables['Usertask']

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!selectedValue) {
      toastr.error('Please make a valid selection before inserting!')
      return
    }
    handleInsertVariable(selectedValue)
  }

  return (
    <form autoComplete="off" onSubmit={handleSubmit}>
      <Grid container lg={12} sm={12} md={12} spacing={2}>
        <ItemGrid xs={12} sm={12} md={6} lg={6}>
          <NestedDropdowns
            node={values}
            onFinalSelect={setSelectedValue}
            path={isOnboarding ? ['User'] : ['Usertask']}
          />
        </ItemGrid>
      </Grid>
      <ButtonStack>
        <Button type="submit"> Insert </Button>
      </ButtonStack>
    </form>
  )
}

const mapStateToProps = (state) => {
  return {
    formValues: getFormValues('insert_variable_form')(state),
    currentCompany: state.currentCompany,
    userPermissions: state.permissions.userPermissions
  }
}

InsertVariableForm = reduxForm({
  form: 'insert_variable_form',
  touchOnChange: true,
  touchOnBlur: true,
  enableReinitialize: true
})(reduxFormTouchOnsubmit(InsertVariableForm))

export default connect(mapStateToProps, null)(InsertVariableForm)
